module.exports = __webpack_public_path__ + "img/img_price_table.7dcf6685.png";